import { useMutation, useQueryClient } from '@tanstack/react-query';
import { submitLenderOnboarding, type OnboardingPayload } from '../api/lenderOnboarding';

export function useSubmitOnboarding() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: OnboardingPayload) => submitLenderOnboarding(payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['lenders'] });
    },
  });
}
